import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    checkbox: {
        color: '#8DD9C8',
        verticalAlign: 'top',
    }
}));

export default useStyles;
